import { Component, Input } from '@angular/core';
var CalendarEventActionsComponent = (function () {
    function CalendarEventActionsComponent() {
    }
    CalendarEventActionsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mwl-calendar-event-actions',
                    template: "\n    <span *ngIf=\"event.actions\" class=\"cal-event-actions\">\n      <a\n        class=\"cal-event-action\"\n        href=\"javascript:;\"\n        *ngFor=\"let action of event.actions\"\n        (mwlClick)=\"action.onClick({event: event})\"\n        [ngClass]=\"action.cssClass\"\n        [innerHtml]=\"action.label\">\n      </a>\n    </span>\n  "
                },] },
    ];
    /** @nocollapse */
    CalendarEventActionsComponent.ctorParameters = function () { return []; };
    CalendarEventActionsComponent.propDecorators = {
        'event': [{ type: Input },],
    };
    return CalendarEventActionsComponent;
}());
export { CalendarEventActionsComponent };
//# sourceMappingURL=calendarEventActions.component.js.map


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/angular-calendar/dist/esm/src/components/common/calendarEventActions.component.js
// module id = ../../../../angular-calendar/dist/esm/src/components/common/calendarEventActions.component.js
// module chunks = 42